/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Calendar_Read_SuccessInputs */

const es_tools_calendar_read_success = /** @type {(inputs: Tools_Calendar_Read_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento de Google leído`)
};

const en_tools_calendar_read_success = /** @type {(inputs: Tools_Calendar_Read_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google event read`)
};

/**
* | output |
* | --- |
* | "Google event read" |
*
* @param {Tools_Calendar_Read_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_calendar_read_success = /** @type {((inputs?: Tools_Calendar_Read_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Calendar_Read_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_calendar_read_success(inputs)
	return en_tools_calendar_read_success(inputs)
});
export { tools_calendar_read_success as "tools.calendar.read_success" }